namespace JupitersChoice {
    export class PlayReelStopCmd {

        @inject('GameServer') _server: Sapphire.GameServer;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('ResponseHelper') _responseHelper: ResponseHelper;
        @inject('StateModel') _stateModel: Sapphire.StateModel;

        execute(reelIdx: number): void {
            const response: any = this._server.logicResponse;
            const spinInfo = this._stateModel.currentSubgame === 'FreeGame' ? response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1] : response;
            const lockedReels = this._responseHelper.getLockedReels(spinInfo.lockedWithPreviousReel);

            if(lockedReels.length == 0 || reelIdx == lockedReels[0] || lockedReels.indexOf(reelIdx) == -1){
                this._soundManager.play('reel_stop');
            }
        }
    }
}